import {useEffect, useState} from 'react';
import config from 'config';
import api from 'services/api';
import './style.css';
import {formatDate, formatImage} from 'components/formatos';

function NotificacaoPage() {
  const [anotificao, setANotificacao] = useState([]);
  const [loading, setLoading] = useState(true);

  function Carrega() {
    setLoading(true);
    api.get(`${config.USUARIOS}/notificacao`)
      .then(response => {
        setANotificacao(response.data);
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    Carrega();
  }, [])

  function DeletaNotificao(id) {
    api.delete(`${config.USUARIOS}/notificacao/${id}`)
      .then(() => {
        Carrega();
      });
  }

  return (
    <div className="notificacoes-page">
      <h1 className="section-title">
        <i className="fas fa-bell" style={{ marginRight: '12px' }}></i>
        Minhas Notificações
      </h1>

      <div className="notification-list">
        {!loading && anotificao.length === 0 && (
          <div className="empty-notifications">
            <div className="empty-icon">
              <i className="fas fa-bell-slash"></i>
            </div>
            <h3>Nenhuma notificação por aqui</h3>
            <p>Avisaremos você assim que algo novo aparecer!</p>
          </div>
        )}

        {anotificao.map((n, index) => {
          const imageUrl = formatImage(n.image);
          return (
            <div key={`nof${index}`} className="notf-card animate-in" style={{animationDelay: `${index * 0.1}s`}}>
              <div className="notf-main">
                <div className="notf-image-wrapper">
                  {imageUrl ? (
                    <img src={imageUrl} alt="Notificação" className="notf-img" />
                  ) : (
                    <div className="notf-icon-placeholder">
                      <i className="fas fa-bell"></i>
                    </div>
                  )}
                </div>
                
                <div className="notf-content">
                  <div className="notf-header">
                    <h3>{n.title}</h3>
                    <span className="notf-date">{formatDate(n.dat_recece, 'dd/mm/yyyy hh:mm')}</span>
                  </div>
                  <p className="notf-body">{n.body}</p>
                </div>
              </div>

              <div className="notf-actions">
                <button 
                  className="btn-delete-notf"
                  type="button" 
                  onClick={() => DeletaNotificao(n.id_message)}
                  title="Excluir notificação"
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            </div>
          );
        })}

        {loading && (
          <div className="loading-placeholder">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default NotificacaoPage;